export const DEMO_COUNTER_PLUS_ONE = 'DEMO_COUNTER_PLUS_ONE';
export const DEMO_COUNTER_MINUS_ONE = 'DEMO_COUNTER_MINUS_ONE';
export const DEMO_COUNTER_RESET = 'DEMO_COUNTER_RESET';